import 'angular-modal-service';

module.exports = angular.module(__filename, [
    'angularModalService',
    require("data/settings/user-mgmt").name
]).service('setPasswordModal', ['ModalService', 'userMgmt', 'notificator', function (ModalService, userMgmt, notificator) {
    this.show = showSetPasswordModal;

    //////////////////////////////

    function showSetPasswordModal(id, showCancel) {
        return ModalService.showModal({
            inputs: {
                userId: id,
                showCancel: showCancel
            },
            template: require('./set-password.html'),
            controller: ['$scope', 'userId', 'showCancel', 'close', SetPasswordController]
        });
    }

    function SetPasswordController($scope, userId, showCancel, close) {
        $scope.pwdConfirmationError = false;
        $scope.update = validateAndUpdate;
        $scope.close = close;
        $scope.showCancel = showCancel;
        $scope.isBusy = false;

        function validateAndUpdate(form) {
            if (form.password == form.passwordConfirm) {
                updatePwd(form);
            } else {
                $scope.pwdConfirmationError = true;
            }
        }

        function updatePwd(form) {
            $scope.isBusy = true;
            userMgmt.resetLegacyPassword(userId, form).then(function (res) {
                notificator.success({body: "Password successfully updated"});
                close(true);
            }, function (error) {
                notificator.error({body: "Password update failed!"});
                close(false);
            });
        }
    }
}]);
